// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-be6b7bae]:export {\n  menuBg: #393997;\n  menuText: #fff;\n  menuActiveText: #409eff;\n}\n\n/* Mixins */\n.scroll-container[data-v-be6b7bae] {\n  white-space: nowrap;\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
